import { useHistory, useLocation } from "react-router-dom";
import * as Styles from "./Challenge.styles";

import MainHeader from "../../../components/Wrapper/HealthAnalyseHeader";
import AwardImage from "assets/images/health-analyse/award.png";
import { CLOSE } from "routes/routes";
import { Checkbox, message } from "antd";
import { useState } from "react";

function Challenge() {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const userPlan = queryParams.get("user") || "pro";
  const refundAmount = queryParams.get("refund") || "0,00";
  const fullPrice =
    queryParams.get("fullPrice") || (userPlan === "pro" ? 450 : 150);
  const refundValue = parseFloat(refundAmount.replace(",", ".")) || 0;

  const [joiningCheckbox, setJoiningCheckbox] = useState(true);
  const handleBtnClick = () => {
    history.push(
      `${CLOSE}?user=${userPlan}&refund=${encodeURIComponent(
        refundAmount
      )}&fullPrice=${fullPrice}`
    );
  };
  return (
    <Styles.Container>
      <div className="main-div">
        <MainHeader
          headline={"Auswertung"}
          subHeadline={" Wir erreichen gemeinsam dein Ziel!"}
          handleNextPage={handleBtnClick}
          noBackButton={true}
        />
        <Styles.ContentSection>
          <Styles.Title>Deine Gesundheit ist uns 1.000€ Wert.</Styles.Title>
          <Styles.Description>
            Mach mit bei der Health Challenge, baue Schritt für Schritt gesunde
            Gewohnheiten in deinen Alltag ein – und sichere dir in den nächsten
            12 Wochen die Chance auf 1.000 €, die wir unter allen Teilnehmenden
            für eine erfolgreich umgesetzte Ernährungsumstellung vergeben.
          </Styles.Description>
          <Styles.AwardSection>
            <div className="award-container">
              <img src={AwardImage} alt="Award" className="award-icon" />
              <div className="content-column">
                <p className="title">Gesunde Gewohnheiten</p>
                <p className="subtitle">12 Wochen Health Challenge</p>
                <p className="description">Starten und gewinnen</p>
              </div>
            </div>
            <h3 className="amount">1.000 €</h3>
          </Styles.AwardSection>
          <div className="joining-section">
            <p className="title">Bist du dabei?</p>
            <div className="checkbox-row">
              <Checkbox
                onChange={() => setJoiningCheckbox(true)}
                checked={joiningCheckbox}
              />
              <p className="checkbox-label">
                Ja unbedingt, ich möchte teilnehmen
              </p>
            </div>
            <div className="checkbox-row">
              <Checkbox
                onChange={() => setJoiningCheckbox(false)}
                checked={!joiningCheckbox}
              />
              <p className="checkbox-label">
                Nein, die Challenge ist nicht das Richtige
              </p>
            </div>
          </div>
          <Styles.Disclaimer>
            Teilnahmebedingungen: Der Gewinn wird unter allen Teilnehmenden der
            Health Challenge verlost, die im Monat des letzten Teilnahmetages
            ihre Challenge erfolgreich abgeschlossen haben.
          </Styles.Disclaimer>
        </Styles.ContentSection>
      </div>

      <button
        onClick={handleBtnClick}
        className="btn-dark w-full mt-8 btn-show"
      >
        Weiter
      </button>
    </Styles.Container>
  );
}

export default Challenge;
